<div class="joined-auction">


  <div class="wallet-current">

    <div class="current-bid">
      <!-- <p class="current-bid-txt">{{itemDetails?.is_closed?("Auction Item.Final Bid"|translate):("Auction Item.Current bid"|translate)}}</p> -->
      <p class="current-bid-txt">{{"Auction Item.Current bid"|translate}}</p>

      <p class="current-bid-price"><span>{{"Auction Item.SR"|translate}}</span>
        {{number}}
      </p>

      <p class="current-bid-txt current-bid-last">{{"Auction Item.Your last bid"|translate}}</p>

      <!-- <ng-container *ngIf="lastbid; else elseTemplate">
                  <p class="current-bid-last-price"><span>{{"Auction Item.SR"|translate}}</span> {{lastbid | kFormat}}
                  </p>
                </ng-container> -->
      <ng-template>
        <p class="current-bid-last-price">{{"Auction Item.You have not bid yet"|translate}}</p>
      </ng-template>



    </div>


    <div class="current-wallet">
      <ng-container *ngIf="showTimer; else elseTemplate55">
        <div class="time-no-bid">
          <div class="text">
            {{"multiAuction.end time if no bid" | translate }}
          </div>
          <div class="timer">
            <span class="minute">{{remainingTimeMinutes}}</span> : <span class="second">{{remainingTimeSeconds}}</span>
          </div>
        </div>
      </ng-container>
      <ng-template #elseTemplate55>
        <div class="w-100 m-auto" style="max-width: 150px;max-height:150px;">
          <app-timer-circle-multi [duration]="duration" [timeLeft]="auctionRemainingTime"></app-timer-circle-multi>
        </div>
      </ng-template>


    </div>

  </div>

  <!-- <div *ngIf="showTimer" class="time-no-bid">{{"multiAuction.end time if no bid" | translate }}
    {{remainingTimeMinutes}}:{{remainingTimeSeconds}}</div> -->


  <div class="bid-amounts pb-4">

    <p class="bid-amounts-txt" *ngIf="itemDetails?.btns?.length">
      {{"Auction Item.Instantly bid amounts"|translate}}</p>
    <div class="bid-amounts-btns" *ngIf="itemDetails?.btns?.length">
      <button *ngFor="let btn of itemDetails.btns" (click)="onAddPrice(btn.price)" class="btn price">
        {{"Auction Item.SR"|translate}}
        {{btn.price}}</button>


    </div>


    <div class="bid-amounts-manually">
      <p class="manually-txt">{{'items-requests.Or add manually' | translate}}</p>
      <div class="manually-control">
        <div [class.disable]="CustomPrice<=0" class="minus"
          [matTooltip]="('Auction Item.Minus'|translate)+' '+itemDetails?.manual_bidding"
          (click)="onAddCustomPrice('minus',itemDetails?.manual_bidding)">
          <img src="assets/images/icons/minus.svg">
        </div>
        <div class="total">
          <!-- <span>SR</span> {{CustomPrice}} -->
          <input type="text" appOnlynumber [(ngModel)]="CustomPrice" maxlength="9">
        </div>
        <div class="plus" (click)="onAddCustomPrice('plus',itemDetails?.manual_bidding)"
          [matTooltip]="('Auction Item.Plus'|translate)+' '+itemDetails?.manual_bidding">
          <img src="assets/images/icons/plus.svg">
        </div>
      </div>
      <div class="manually-action">
        <button (click)="onSendCustomPrice()" class="btn "> {{'items-requests.Submit Bid' |translate}}</button>
      </div>
    </div>

  </div>



</div>